import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PatientSearchComponent } from './patient-search.component';
import { TranslateModule } from '../../../../shared/translate/translate.module';
import { SinControllerModule } from '../../sin-controller/sin-controller.module';


@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule, SinControllerModule],
  declarations: [PatientSearchComponent],
  exports: [PatientSearchComponent]
})
export class PatientSearchModule { }
